import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const RedoFulfillmentToteGroupSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  name: z.string(),
});

export type RedoFulfillmentToteGroup = z.infer<
  typeof RedoFulfillmentToteGroupSchema
>;
